// Social Service
import api from './api';

export const getLeaderboard = async (period = 'all_time', metric = 'volume') => {
  const response = await api.get('/social/leaderboard', {
    params: { period, metric }
  });
  return response.data;
};

export const getUserProfile = async (userId) => {
  const response = await api.get(`/social/profile/${userId}`);
  return response.data;
};

export const compareUsers = async (userId, period = '30') => {
  const response = await api.get(`/social/compare/${userId}`, {
    params: { period }
  });
  return response.data;
};

export const updatePrivacy = async (settings) => {
  const response = await api.post('/social/privacy', settings);
  return response.data;
};

export const searchUsers = async (query) => {
  const response = await api.get('/social/search', {
    params: { q: query }
  });
  return response.data;
};
